import React from "react";
import { Box } from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";

type Props = {
  label: string;
  selected: boolean;
  onClick: () => void;
  big?: boolean;
};

/** Multi-select chip (allergies). Selected = brown border on white; idle = cream tile. */
export const StyledChoicePill = ({ label, selected, onClick, big }: Props) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        px: big ? "22px" : "18px",
        py: big ? "11px" : "9px",
        borderRadius: QUIZ.radius.pill,
        fontFamily: QUIZ.font.body,
        fontSize: big ? "16px" : "15px",
        fontWeight: 700,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: "all 0.18s ease",
        backgroundColor: selected ? QUIZ.color.white : QUIZ.color.cream2,
        color: selected ? QUIZ.color.brown : QUIZ.color.grey,
        border: selected ? `2px solid ${QUIZ.color.brown}` : `1px solid ${QUIZ.color.cream3}`,
        "&:hover": { borderColor: QUIZ.color.brown },
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </Box>
  );
};
